import { ActionReducerMap } from '@ngrx/store';
import {navReducer, NavState} from "./navigation/navigation.reducer";
import {historyReducer, HistoryState} from "./history/history.reducer";

export interface AppState {
  nav: NavState;
  history: HistoryState;
}

export const appReducers: ActionReducerMap<AppState> = {
  nav: navReducer,
  history: historyReducer
};
